import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, filespaceVersionParser, memberEncryptionTypeParser, memberRoleParser, memberScimStatusParser, memberStatusParser, memberTypeParser, principalProviderParser, privilegeParser, } from '#validation';
import { InvitationResponseSchema } from '#web-service-api/invitation/response';
import { userRefSchema } from '#web-service-api/user';
import { WorkspaceCryptoResponseSchema } from '#web-service-api/workspace/response';
import { FilespaceAdminForSchema } from './filespace-admin-for.schema';
export const CurrentMemberResponseSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    role: memberRoleParser,
    type: memberTypeParser,
    status: memberStatusParser,
    scimStatus: memberScimStatusParser,
    encryptionType: memberEncryptionTypeParser,
    privileges: z.array(privilegeParser),
    filespaceAdminFor: FilespaceAdminForSchema.nullish(),
    publicKey: z.string(),
    ePrivateKeyByUserKey: z.string().nullish(),
    ePrivateKeyByInvitationKey: z.string().nullish(),
    eInvitationPrivateKeyByMemberKey: z.string(),
    // service accounts have no user
    user: userRefSchema.nullable(),
    invitation: InvitationResponseSchema,
    workspace: WorkspaceCryptoResponseSchema,
    workspaceKey: z.string().nullish(),
    provider: principalProviderParser,
    joinedOn: dateParser(),
    updatedAt: dateParser(),
});
export class CurrentMemberResponseDto extends createZodDto(CurrentMemberResponseSchema) {
}
export const SsoCryptoSchema = z.object({
    seSsoSecretKeyByAdminKey: z.string(),
    sSsoSecretKeyByAdminKey: z.string(),
    ssoGroupsPublicKey: z.string(),
    sSsoGroupsPublicKeyByAdminKey: z.string(),
    eSsoGroupsPrivateKeyByAdminKey: z.string(),
});
export const AdminMemberResponseSchema = CurrentMemberResponseSchema.extend({
    eAdminPrivateKeyByMemberKey: z.string(),
    ssoCrypto: SsoCryptoSchema.nullish(),
    workspaceConfig: z
        .object({
        minFilespaceVersion: filespaceVersionParser.nullish(),
        m001_workspaceKeyRequiredForInvitation: z.boolean(),
        m002_workspaceKeySetForAllInvitations: z.boolean(),
        m003_legacyDomainsKeysMigrated: z.boolean(),
    })
        .nullable(),
});
export class AdminMemberResponseDto extends createZodDto(AdminMemberResponseSchema) {
}
